var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.748,
    height: 24.37,
    viewBox: "0 0 25.748 24.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attach",
    transform: "translate(-0.001 -13.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0.001 13.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M23.338,16.113a8.241,8.241,0,0,0-11.64,0L1.72,26.091a5.879,5.879,0,0,0,8.315,8.315l9.146-9.146a3.527,3.527,0,1,0-4.989-4.989L8.211,26.252a1.176,1.176,0,1,0,1.663,1.663l5.981-5.981A1.176,1.176,0,1,1,17.518,23.6L8.372,32.743a3.528,3.528,0,0,1-4.989-4.989l9.978-9.978a5.879,5.879,0,1,1,8.315,8.315L11.7,36.069a1.176,1.176,0,0,0,1.663,1.663l9.978-9.978a8.231,8.231,0,0,0,0-11.64Z",
    transform: "translate(-0.001 -13.707)",
    fill: "#3b56a7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.f66c47d551a565025e70a4c2b39b7a06.svg";
export { ForwardRef as ReactComponent };